import { customAlphabet } from 'nanoid';

const generateNanoId = ({ length = 6 }) =>
  customAlphabet(
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
    length
  )();

export default generateNanoId;
